import { Box, Grid, Typography, IconButton } from "@mui/material";
import "./calendar.css";
import MenuIcon from "@mui/icons-material/Menu";
import React, { useContext, useEffect, useState } from "react";
import ApiService from "../../functions/apiService";
import CalendarPicker from "../../components/Calendar/CalendarPicker";
import { convertCalendarObjectToArray, swapKeysAndValues } from "../../utils/helperFunctions";
import CalendarLoader from "../../components/Calendar/CalendarLoader";
import Notes from "../../components/Calendar/Notes";
import { useNavigate, useSearchParams } from "react-router-dom";
import ManagementHeaderNav from "../../components/HeadersNav/ManagementHeaderNav";
import moment from "moment/moment";
import AuthContext from "../../context/AuthContext";

const Calendar = () => {
  let navigate = useNavigate();
  const [calendar, setCalendar] = useState({});
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [notes, setNotes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [noteLoading, setNoteLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [isNotesOpen, setIsNotesOpen] = useState(1);
  const routeDate = searchParams.get('date');
  const { pages } = useContext(AuthContext);

  const getCalendar = async () => {
    setLoading(true);
    const response = await ApiService.get(`/calendar/${selectedDate.getFullYear()}/${selectedDate.getMonth() + 1}`, {}, 'calendar');
    setCalendar(response.data);
    setLoading(false);
  };

  const getNotes = () => {
    setNoteLoading(true)
    let month = ('0' + (selectedDate.getMonth() + 1)).slice(-2);
    ApiService.get(`/notes/${selectedDate.getFullYear()}/${month}`, {}, 'notes').then(({ data }) => {
      setNoteLoading(false)
      setNotes(data.data);
    }).catch(() => setNoteLoading(false));
  };

  // useEffect(() => {
  //   if (routeDate && routeDate != selectedDate) {
  //     setSelectedDate(new Date(routeDate))
  //   }
  // }, [])

  useEffect(() => {
    setSearchParams({ date: moment(selectedDate).format('YYYY-MM') });
    getCalendar();
    getNotes();
  }, [selectedDate]);

  const calendarArr = convertCalendarObjectToArray(calendar?.calendar || {});
  const events = swapKeysAndValues(calendar?.events || {});

  let RedirectToSchedual = (date) => {
    navigate('/firehouse/schedule?date=' + date)
  }

  const recalculateSeniority = () => {
      ApiService.get('/checkForRecalculateSeniorityRequest')
        .catch((e) => {
          console.error(e || 'error')
        })
  }

  useEffect(()=>{
    if(pages && pages.includes('V3_RECALCULATE_SENIORITY')){
          recalculateSeniority();
    }
  } , [])


  return (
    <>
      <ManagementHeaderNav />
      <div style={{ overflow: 'hidden', backgroundColor: "#fff", marginTop: '20px' }}>
        <div
          style={{
            marginLeft: isNotesOpen == 1 ? '24%' : '34%',
            transition: 'margin-left 0.2s ease',
          }}
        >
          <CalendarPicker selectedDate={selectedDate} setSelectedDate={setSelectedDate} />
        </div>

        <Grid className="m-0" container spacing={2} columns={{ xs: 5, lg: 10 }}>
          <Grid item xs={5}
            lg={isNotesOpen == 1 ? 7 : 9}
            style={{ paddingRight: pages.includes('CALENDER_DISPLAY_NOTES') ? '10px' : '30px', transition: 'all 0.2s ease-in-out' }}>
            <Box backgroundColor="#fff">
              <Box display="flex" flexWrap="wrap" borderTop="2px solid #cac9c9" borderLeft="2px solid #cac9c9" borderRight="2px solid #cac9c9">
                <div className="calendar-header-item">
                  <Typography fontWeight="600" style={{ marginLeft: '35%' }}>SUN</Typography>
                </div>
                <div className="calendar-header-item">
                  <Typography fontWeight="600" style={{ marginLeft: '35%' }}>MON</Typography>
                </div>
                <div className="calendar-header-item">
                  <Typography fontWeight="600" style={{ marginLeft: '35%' }}>TUE</Typography>
                </div>
                <div className="calendar-header-item">
                  <Typography fontWeight="600" style={{ marginLeft: '35%' }}>WED</Typography>
                </div>
                <div className="calendar-header-item">
                  <Typography fontWeight="600" style={{ marginLeft: '35%' }}>THUR</Typography>
                </div>
                <div className="calendar-header-item">
                  <Typography fontWeight="600" style={{ marginLeft: '35%' }}>FRI</Typography>
                </div>
                <div className="calendar-header-item">
                  <Typography fontWeight="600" style={{ marginLeft: '35%' }}>SAT</Typography>
                </div>
              </Box>
              {loading ? (
                <CalendarLoader />
              ) : (
                <Box display="flex" flexWrap="wrap" borderTop='2px solid #cac9c9' borderRight='2px solid #cac9c9'>
                  {calendarArr?.map((item, index) => {
                    return (
                      <Box key={index} onClick={() => RedirectToSchedual(item.date)}
                        className="calendar-header-item position-relative" borderBottom="2px solid #cac9c9" borderLeft="2px solid #cac9c9"
                        style={{ cursor: 'pointer', minHeight: '126px', backgroundColor: moment(item.date).isSame(new Date, 'day') ? "rgba(191, 29, 45, 0.2)" : 'transparent' }}>
                        <Typography fontSize="24px" variant="h6" marginBottom="20px">
                          {Number(item.date[8]) > 0 && item.date[8]}
                          {item.date[9]}
                        </Typography>
                        {events[item.date] ? (
                          <Typography fontSize="14px" variant="span" className="shift-count">
                            {events[item.date]}
                          </Typography>
                        ) : (
                          <Typography fontSize="14px" variant="span"></Typography>
                        )}
                        {calendar && calendar.overtime && calendar.overtime.filter((i) => i.shiftDate == item.date).length > 0 ?
                          calendar.overtime.filter((i) => i.shiftDate == item.date).map(overtime => (
                            <Typography fontSize="14px" style={{ color: overtime.color }} >
                              {overtime?.shiftText ? overtime?.shiftText : overtime.count + ' ' + overtime.statusText}  &nbsp;   &nbsp;
                            </Typography>
                          ))
                          :
                          <br />
                        }
                        {calendar && calendar.overtimeRequset && calendar.overtimeRequset.filter((i) => i.shiftDate == item.date).length > 0 ?
                          calendar.overtimeRequset.filter((i) => i.shiftDate == item.date).map(overtime => (
                            <Typography fontSize="14px" style={{
                              color: overtime.color
                              //  color: 'purple'
                            }} >
                              {overtime.count + ' Requests'}  &nbsp;   &nbsp;
                            </Typography>
                          ))
                          :
                          <br />
                        }
                        <br />
                        <div className="position-absolute bottom-0  mb-1">
                          {item?.groupName?.map((group, i) => {
                            return <Typography fontSize="14px" color={item.groupColor[i]} variant="span" className="shift-count ">
                              {group}
                            </Typography>
                          })}
                        </div>
                      </Box>
                    );
                  })}
                </Box>
              )}
            </Box>
          </Grid>
          {pages.includes('CALENDER_DISPLAY_NOTES') && (
            <Grid
              item
              xs={5}
              lg={isNotesOpen == 1 ? 3 : 1}
              className="p-1"
              style={{ marginTop: '12px', transition: 'all 0.2s ease-in-out' }}
            >
              <Notes notes={notes} loading={noteLoading} setIsNotesOpen={setIsNotesOpen} isNotesOpen={isNotesOpen} />
            </Grid>
          )}
        </Grid>
      </div>
    </>
  );
};

export default Calendar;
